export function sanitizeEditableMultiLine(txt, allowLeftSpace = false) {
    const t = (allowLeftSpace ? txt : txt === null || txt === void 0 ? void 0 : txt.replace(/^\s+/, '')) || '';
    return t.replace(/[^\x09\x0A\x0D\x20-\uD7FF\uE000-\uFFFD]+$/, '');
}
export function sanitizeEditable(txt) {
    const t = (txt === null || txt === void 0 ? void 0 : txt.replace(/^\s+/, '')) || '';
    return t.replace(/[^\x20-\uD7FF\uE000-\uFFFD]+$/, '');
}
// Unicode bidirectional control/override characters (the "Trojan Source" class)
// and zero-width characters. These are invisible and can be used to spoof how a
// string renders (e.g. make a URL or name display differently than it reads), so
// they are stripped globally from sanitized single-line/character fields. Covers
// the bidi marks (LRM/RLM/ALM), embeddings/overrides (U+202A\u2013U+202E), isolates
// (U+2066\u2013U+2069), zero-width spaces/joiners (U+200B\u2013U+200D) and the BOM.
const BIDI_AND_ZERO_WIDTH = /[\u061C\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g;
export function sanitizeCharacters(txt, maxLength = 4096) {
    return (txt || '').replace(BIDI_AND_ZERO_WIDTH, '').trim().replace(/[^\x09\x0A\x0D\x20-\uD7FF\uE000-\uFFFD]+$/, '').slice(0, maxLength);
}
export function sanitizeSingleLine(txt, maxLength = 1024) {
    return (txt || '').replace(BIDI_AND_ZERO_WIDTH, '').trim().replace(/[^\x20-\uD7FF\uE000-\uFFFD]+$/, '').slice(0, maxLength);
}
export function sanitizeNoWhitespace(value, maxLength = 128) {
    return (value || '').replace(BIDI_AND_ZERO_WIDTH, '').replace(/[^\x21-\uD7FF\uE000-\uFFFD]+$/, '').slice(0, maxLength);
}
export function sanitizeIdChars(value, maxLength = 64) {
    return (value || '').replace(/[^0-9a-zA-Z_$-]+$/, '').slice(0, maxLength);
}
export function sanitizeEmail(email) {
    if (!email.includes('@') || email.length > 256)
        return undefined;
    const cleaned = email.toLowerCase().replace(/\s+|(\.+$)|[<>&]+/g, '');
    if (cleaned.length > 5 && cleaned.length < 256 && /@.+\.\w+$/.test(cleaned))
        return cleaned;
    else
        return undefined;
}
export function sanitizePhoneNumber(phone) {
    if (phone.length > 20)
        return undefined;
    const trimmed = phone.replace(/\s+/g, '');
    const cleaned = trimmed.startsWith('+') ?
        `+${trimmed.substring(1).replace(/\D/g, '')}`
        : `+1${phone.replace(/\D/g, '')}`;
    if (cleaned.length > 5 || cleaned.length < 16)
        return cleaned;
    else
        return undefined;
}
/**
 * Removes all HTML tags and decodes HTML entities, converting to plain text
 * @param html - The HTML string to sanitize
 * @returns Plain text with HTML tags removed and entities decoded
 */
export function sanitizePlainText(html) {
    if (!html)
        return '';
    // Remove all HTML tags
    let text = html.replace(/<[^>]*>/g, '');
    // Decode HTML entities
    text = text.replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, "'")
        .replace(/&nbsp;/g, ' ');
    return text;
}
/**
 * Truncates a string to a maximum length, adding ellipsis if truncated
 * @param text - The text to truncate
 * @param maxLength - Maximum length before truncation
 * @returns Truncated text with '...' appended if needed
 */
export function sanitizeLongText(text, maxLength) {
    if (!text)
        return '';
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
}
